import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { ExchangeRates } from "./exchange-rates.entity";
import { exchangeRatesController } from "./exchange-rates.controller";
import { ExchangeRatesService } from "./exchange-rates.service";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { LogsService } from "@gtpl/shared-services/user-logs";
import { Currencies } from "../currencies/currencies.entity";

@Module({
    imports: [
         TypeOrmModule.forFeature([ExchangeRates,Currencies]),
    ],
    controllers: [exchangeRatesController],
    providers: [ExchangeRatesService,ApplicationExceptionHandler,LogsService],
    exports: [ExchangeRatesService],
  })
  export class ExchangeRatesModule {}

